module.exports = __webpack_public_path__ + "img/berts-logo-header.b47317c7.png";